import { render, staticRenderFns } from "./GrossSalesKPM.vue?vue&type=template&id=7dea6755"
import script from "./GrossSalesKPM.vue?vue&type=script&lang=js"
export * from "./GrossSalesKPM.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/websites/streamlined-business-solutions/sbs-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7dea6755')) {
      api.createRecord('7dea6755', component.options)
    } else {
      api.reload('7dea6755', component.options)
    }
    module.hot.accept("./GrossSalesKPM.vue?vue&type=template&id=7dea6755", function () {
      api.rerender('7dea6755', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboard/reports/GrossSalesKPM.vue"
export default component.exports